export default __webpack_public_path__ + "static/poetry-23c157674f30ba680b0df3e3c05f3827.jpg";